var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHardHatActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_650_15440)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.12483 27.125C8.56125 27.6886 7.79686 28.0052 6.99983 28.0052C6.2028 28.0052 5.43842 27.6886 4.87483 27.125C4.31125 26.5614 3.99463 25.797 3.99463 25C3.99463 24.203 4.31125 23.4386 4.87483 22.875L12.8461 15.59C12.1147 14.1363 11.8441 12.4941 12.0702 10.8826C12.2964 9.27106 13.0087 7.76683 14.112 6.57063C15.2153 5.37442 16.6571 4.54313 18.2452 4.18768C19.8332 3.83223 21.4919 3.96953 22.9998 4.58125L17.9998 10L18.7073 13.2925L21.9998 14L27.4186 9C28.0298 10.5082 28.1666 12.167 27.8106 13.7549C27.4546 15.3429 26.6228 16.7845 25.4262 17.8874C24.2295 18.9903 22.725 19.7021 21.1133 19.9277C19.5017 20.1533 17.8595 19.882 16.4061 19.15L9.12483 27.125Z",
    stroke: "#A68AFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_650_15440"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHardHatActive);
export default __webpack_public_path__ + "static/media/HardHatActive.b7eb0509fb6640c18e8e4e738289f5fb.svg";
export { ForwardRef as ReactComponent };